import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-lookups',
  templateUrl: './lookups.component.html'
})
export class LookupsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
